import React, { useCallback } from 'react';
import { LoadingButton } from '@atlaskit/button';
import SearchIcon from '@atlaskit/icon/glyph/editor/search';
var style = {
  // Fixes an issue where loading button makes the editor flicker with a scrollbar
  overflow: 'hidden'
};
export var BaseSearch = function BaseSearch(_ref) {
  var isDisabled = _ref.isDisabled,
    isSearching = _ref.isSearching,
    label = _ref.label,
    onSearch = _ref.onSearch;
  // Prevent click events being repeatedly fired if the Enter key is held down.
  var preventRepeatClick = useCallback(function (e) {
    if (e.key === 'Enter' && e.repeat) {
      e.preventDefault();
    }
  }, []);
  return /*#__PURE__*/React.createElement(LoadingButton, {
    "aria-label": label,
    isDisabled: isDisabled,
    testId: "jql-editor-search",
    style: style,
    appearance: 'primary',
    spacing: 'none',
    onClick: onSearch,
    onKeyDown: preventRepeatClick,
    isLoading: isSearching,
    iconBefore: /*#__PURE__*/React.createElement(SearchIcon, {
      label: '',
      size: 'medium'
    })
  });
};